@file:OptIn(InternalResourceApi::class)

package animations.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/animations.composeapp.generated.resources/"

@delegate:ResourceContentHash(-241_356_811)
internal val Res.string.about: StringResource by lazy {
      StringResource("string:about", "about", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 721),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("about", Res.string.about)
}
